var _style, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWave2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 115.4 40",
    style: {
      enableBackground: "new 0 0 115.4 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF65AF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.4,16c-9.3,0-9.2,3.4-20.4,3.4c-8.8,0-9-3.4-18.1-3.4c-9.3,0-9.2,3.4-20.4,3.4c-8.8,0-9-3.4-18.1-3.4 c-9.3,0-9.2,3.4-20.4,3.4v16.2h38.4h38.5h38.5V19.5C106.7,19.5,106.4,16,97.4,16z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave2);
export default __webpack_public_path__ + "static/media/wave_2.7651ec670292016c57c2347e7a42e796.svg";
export { ForwardRef as ReactComponent };